import React from 'react'
import { Youtube } from '../../assets/images'
import styled from 'styled-components'
import { useContext } from 'react'
import authContext from '../../context/auth-context'

const HeroImageWrapper = styled.div`
    position: relative;
    img{
      width:100%;
      min-height: 200px;
      box-shadow: rgba(77, 75, 50, 0.72) -8px 12px 120px 15px;
      /* margin-bottom: 30px; */
      scale:1;
    }
    .custom-margin{
      margin-top:80px;
    }
    .youtube{
      padding: 10px;
      border: 1px solid var(--border);
    }
    .custom-class-for-subscribers{
      display:flex; 
      justify-content:center; 
      flex-direction:column; 
      background-color:transparent; 
      align-items:center; 
      padding: 0px 50px;
      h2, h3{
        font-weight:400;
        background-color:transparent;
        color:var(--border);
        font-size: 3rem;
        margin-bottom: 0px !important;
      }
      h3{
        font-size: 2rem;
      }
    }
    .custom-class-for-views{
      left:63%;
    }
    @media screen and (max-width:1440px){
      .custom-class-for-subscribers{
        top:26%;
        left:25%;
        padding: auto 80px;
        h2{
          font-size: 1.6rem ;
        }
        h3{
          font-size: 1.2rem ;
        }
      }
      .custom-class-for-views{
        left:63%;
      }
    }
    @media screen and (max-width:1024px){
      .custom-class-for-subscribers{
        top:22%;
        left:24%;
        padding: auto 30px;
        h2{
          font-size: 1.2rem ;
        }
        h3{
          font-size: 0.9rem ;
        }
      }
      .custom-class-for-views{
        left:63%;
      }
    }
    @media screen and (max-width:768px){
      .custom-margin{
        margin-top: 20px;
        object-fit: contain;
        height: 221px;
        width: 100%;
      }
      .youtube{
        margin-top: 20px;
        object-fit: cover;
        height: 108px;
        width: 100%;
      }
      .custom-class-for-subscribers{
        top:35%;
        left:10%;
        padding: 0px 40px;
        h2{
          font-size: 1rem ;
        }
        h3{
          font-size: 0.5rem ;
        }
      }
      .custom-class-for-views{
        left:76%;
      }
    }

    @media screen and (max-width:435px){
      .custom-class-for-subscribers{
        top:40%;
        left:10%;
        h2{
          font-size: 11px !important;
        }
        h3{
          font-size: 9px !important;
        }
      }
      .custom-class-for-views{
        left:75%;
      }
    }
    
    @media screen and (max-width:320px){
      .custom-class-for-subscribers{
        h2{
          font-size: 1rem ;
        }
        h3{
          font-size: 0.5rem ;
        }
      }
    }
`

const HeroImage = () => {
  const {state, banner} = useContext(authContext)
  return (
    <HeroImageWrapper>
      <img className='custom-margin' src={banner} alt='' /> 
      <div className='d-flex' style={{border:"1px solid var(--border)", padding:10, aspectRatio: 6681 / 800, alignItems:'center', backgroundSize:"cover", backgroundRepeat:"no-repeat", position:"relative", zIndex:50, justifyContent:"space-between", height:'auto', width:"100%", backgroundImage:`url('${Youtube}')`}}>
        <div className='custom-class-for-subscribers'>
          <h2>{state?.aboutme?.subscribers[0]?.subscribers}{state?.aboutme?.subscribers[0]?.subscribers && '+'}</h2>
          <h3>Subscribers</h3>
        </div>
        <div className='custom-class-for-subscribers custom-class-for-views'>
          <h2>{state?.aboutme?.subscribers[0]?.views}{state?.aboutme?.subscribers[0]?.views && '+'}</h2>
          <h3>Views</h3>
        </div>
      </div>
    </HeroImageWrapper>
  )
}

export default HeroImage